const d3 = require('d3');

export default function (chartEl, boxes, prices, yAxisLimits) {
  let minDate, maxDate, totalDays, minBeginningDistanceDays, startDates;
  const boxesContainer = d3
    .select(chartEl)
    .append('div')
    .attr('class', 'line-chart-box__container');

  drawBoxes();

  function drawBoxes() {
    const boxesOutOfField = [];
    startDates = {};

    minDate = prices[0].date;
    maxDate = prices[prices.length - 1].date;
    totalDays = daysBetween(minDate, maxDate);
    minBeginningDistanceDays = totalDays / 30; // make sure to have space at the left

    for (let box of boxes) {
      if (
        box.start_date <
        addDays(minDate, minBeginningDistanceDays + totalDays * 0.064)
      ) {
        boxesOutOfField.push(box);
        continue;
      }

      drawGuruBox(box);
    }

    drawSummaryBox(boxesOutOfField);
  }

  function drawGuruBox(box) {
    const params = {
      boxHeight: 64,
      className: 'js-line-chart-box-' + box.uid + ' ',
      isInsiderTrade: box.is_insider_trade,
    };

    if (box.type === 'buy') {
      params.text = 'shares purchased';
      params.className += 'line-chart-box--buy';
    } else {
      params.text = 'shares sold';
      params.className += 'line-chart-box--sell';
    }

    if (params.isInsiderTrade) {
      params.className += ' line-chart-box--insider-trade';
    }

    params.text = box.shares + '<span>' + params.text + '</span>';
    drawBox(params, box.start_date, box.end_date);
  }

  function drawSummaryBox(boxes) {
    const params = { boxHeight: 64 };

    if (boxes.length <= 0) {
      return;
    }

    const count = countTypesOf(boxes);
    const purchasesText = pluralize('purchase', count.purchases);
    const sellsText = pluralize('sell', count.sells);
    params.text =
      '&#x3c; Earlier<br><span>' +
      purchasesText +
      '<br>' +
      sellsText +
      '</span>';
    params.className = 'line-chart-box--neutral';
    const startDate = addDays(minDate, minBeginningDistanceDays);
    const endDate = addDays(startDate, 90);
    drawBox(params, startDate, endDate);
  }

  function countTypesOf(boxes) {
    const count = { purchases: 0, sells: 0 };

    for (let box of boxes) {
      if (box.type === 'buy') {
        count.purchases += 1;
      } else {
        count.sells += 1;
      }
    }

    return count;
  }

  function drawBox(params, startDate, endDate) {
    const boxWidthInDays = daysBetween(startDate, endDate);
    const diffDays = daysBetween(minDate, endDate) - boxWidthInDays;
    const filtered = prices
      .filter((d) => d.date >= startDate && d.date <= endDate)
      .map((d) => d.close);
    const max = Math.max(...filtered);

    const div = boxesContainer
      .append('div')
      .attr('class', 'line-chart-box ' + params.className)
      .style('left', (diffDays / totalDays) * 100 + '%')
      .style('width', (boxWidthInDays / totalDays) * 100 + '%')
      .html(!params.isInsiderTrade && params.text);

    if (!params.isInsiderTrade && div.node().clientWidth < 54) {
      div.attr('class', div.attr('class') + ' line-chart-box--small');
      params.boxHeight = 16;
    }

    div.style(
      params.cssAttribute || 'height',
      'calc(' +
        ((max - yAxisLimits.min) / (yAxisLimits.max - yAxisLimits.min)) * 100 +
        '% + ' +
        params.boxHeight +
        'px)'
    );
  }

  function resize(newPrices, newYAxisLimits) {
    prices = newPrices;
    yAxisLimits = newYAxisLimits;
    boxesContainer.html('');
    drawBoxes();
  }

  return {
    resize: resize,
  };
}

function pluralize(word, count) {
  return count + ' ' + word + (count === 1 ? '' : 's');
}

function addDays(date, days) {
  let result = new Date(date);
  result.setDate(result.getUTCDate() + days);
  return result;
}

function daysBetween(date1, date2) {
  const oneDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
  return Math.round(Math.abs((date1.getTime() - date2.getTime()) / oneDay));
}
